import * as yup from "yup";

export interface LoginFormValues {
    email: string;
    password: string;
}

export const loginSchema = yup
    .object({
        email: yup.string().required("Kolom wajib diisi"),
        password: yup.string().required("Kolom wajib diisi"),
    })
    .required();
